import React, { Component} from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import _ from "underscore";
import moment from "moment";
//actions
import { actions } from "actions/resources";
import { searchChallenges } from "actions/search";
//antd
import { Button, Col, Dropdown, Icon, Input, Menu, Table, Row } from "antd";
import ChallengeCarousel from "./carousel";
import { getUser } from "utils/auth";

export class Challenges extends Component {

  state = {
    rows: [],
    loadFromStore: true
  };

  componentWillMount() {
    this._fetchDependencies();
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.loadFromStore) {
      this.setState({
        rows: nextProps.challengesAlgolia.hits,
        loadFromStore: false
      });
    }
  }

  _fetchDependencies = async () => {
    const { searchChallenges } = this.props;
    searchChallenges();
  };

  _filterChallenges = challenges => {
    const filteredChallenges = _.filter(
      challenges,
      challenge =>
        moment().subtract(7, "days") < moment(challenge.created_at) &&
        challenge.status === "created"
    );
    filteredChallenges.slice(0, 7);
    return filteredChallenges;
  };

  _onSearchInput = e => {
    const { searchChallenges } = this.props;

    this.setState({
      loadFromStore: true
    });

    searchChallenges(e.target.value);
  };


  _deleteChallanges = async (id) => {
    const { deleteChallenge } = this.props;
    // console.log("_deleteChallanges", id);

    let confirmDelete = window.confirm("Confirm Delete Challange");
    if (confirmDelete) {

      deleteChallenge(id);

      const filteredChallenges = _.filter(this.state.rows, challenge => {
        return challenge.id !== id;
      });

      this.setState({
        rows: filteredChallenges
      });
    }

  };

  render() {
    const { redirect } = this.props;
    const Search = Input.Search;
    const columns = [
      {
        width: 400,
        title: "Challenge Name",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => {
          if (a.name && b.name) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
          }
          return "";
        },
        render: (text, record) => {
          return (
            <div>
              <Link to={`/challenges/edit/${record.id}`}>
                {record.name || "N/A"}
              </Link>
            </div>
          );
        }
      },
      {
        width: 300,
        title: "Company Name",
        dataIndex: "company_name",
        key: "company_name",
        sorter: (a, b) => {
          return a.company_name
            .toLowerCase()
            .localeCompare(b.company_name.toLowerCase());
        },
        render: (text, record) => {
          return (
            <div>
              <Link to={`/companies/edit/${record.company_id}`}>
                {record.company_name}
              </Link>
            </div>
          );
        }
      },
      {
        width: 200,
        title: "Create Date",
        key: "created_at",
        align: "center",
        render: a => {
          return moment(a.created_at).format("M/D/YYYY");
        }
      },
      {
        width: 200,
        key: "action",
        render: (text, record, e) => {
          const menu = (
            <Menu>
              <Menu.Item key="1">
                <a
                  onClick={() =>
                    redirect(
                      `/challenges/admin/${record.id}?company_name=${record.company_name
                      }`
                    )
                  }
                >
                  View Admin Page
                </a>
              </Menu.Item>
              <Menu.Item key="2">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${process.env.REACT_APP_WEB_URL}/challenges/preview/${record.id
                    }?user_id=${getUser().id}`}
                >
                  Challenge Preview
                </a>
              </Menu.Item>

              <Menu.Item key="3">
                <a
                  onClick={() =>
                    this._deleteChallanges(record.id)
                  }
                >
                  Delete
                </a>
              </Menu.Item>
            </Menu>
          );
          return (
            <span>
              <Dropdown placement="bottomCenter" overlay={menu}>
                <a>
                  <Icon type="setting" />
                </a>
              </Dropdown>
            </span>
          );
        }
      }
    ];

    if (this.state.rows) {
      return (
        <div className="detail-spacer">
          <Row type="flex" align="middle">
            <Col span={18}>
              <h1 id="header">New Challenges</h1>
            </Col>
            <Col span={6}>
              <Row type="flex" justify="end">
                <Link to="/challenge/new">
                  <Button type="primary">Create Challenge</Button>
                </Link>
              </Row>
            </Col>
          </Row>
          <Row>
            <ChallengeCarousel
              resourceName="challenge"
              items={this._filterChallenges(this.state.rows)}
              redirect={redirect}
            />
          </Row>
          <Row>
            <Col type="flex" justify="center" align="middle">
              <Search
                placeholder="Search challenges"
                onChange={this._onSearchInput}
              />
            </Col>
          </Row>
          <br />
          <Row justify="center" align="middle">
            <Table
              columns={columns}
              dataSource={this.state.rows}
              rowKey="objectID"
              size="small"
              scroll={{ x: 600 }}
            />
          </Row>
        </div>
      );
    }
    return null;
  }
}

export default connect(
  state => ({
    challenges: state.resources.collection.challenge || [],
    challengesAlgolia: state.search.challengesAlgolia || []
  }),
  dispatch => ({
    fetchChallenges: bindActionCreators(actions.fetchChallenges, dispatch),
    deleteChallenge: bindActionCreators(actions.deleteChallenge, dispatch),
    redirect: bindActionCreators(push, dispatch),
    searchChallenges: bindActionCreators(searchChallenges, dispatch)
  })
)(Challenges);



// WEBPACK FOOTER //
// ./src/components/dashboard/challenge/index.js